import { request } from './helper';
import { CHECKR_VERIFICATIONS_API_BASE } from '../constants';

// The locations a schedule verification can be booked at, optionally near a
// zipcode. `fetchVerification` reads them for a schedule verification.
export const fetchLocations = (verificationId, zipcode) => {
  let path = `${CHECKR_VERIFICATIONS_API_BASE}/schedule_verifications/${verificationId}/locations`;
  if (zipcode) {
    path += `?zipcode=${zipcode}`;
  }
  return request(path);
};
